import { useEffect, useState } from "react";
import { Currency } from "@app/types/currencies";
import { DEFAULT_RATE_INFO } from "./constants";
import { getAlpianExchange } from "./helpers";
import { ExchangeRateResponse, RatesInfo } from "./types";

const DEFAULT_STATE: Record<Currency, RatesInfo> = {
  [Currency.CHF]: DEFAULT_RATE_INFO,
  [Currency.EUR]: DEFAULT_RATE_INFO,
  [Currency.GBP]: DEFAULT_RATE_INFO,
  [Currency.USD]: DEFAULT_RATE_INFO,
};

export const useCurrencyRates = () => {
  const [rates, setRates] = useState(DEFAULT_STATE);

  useEffect(() => {
    const controller = new AbortController();

    const fetchRates = async (baseCurrency: Currency) => {
      try {
        const response = await fetch(
          `https://api.exchangeratesapi.io/v1/latest?access_key=${
            process.env.GATSBY_EXCHANGE_RATE_API_KEY
          }&base=${baseCurrency}&symbols=${Object.values(Currency)}`,
          { signal: controller.signal },
        );

        if (!response.ok) {
          throw new Error("Failed to get exchange rate");
        }

        const data = (await response.json()) as ExchangeRateResponse;

        setRates((state) => ({
          ...state,
          [baseCurrency]: {
            rates: Object.entries(data.rates).reduce(
              (rates, [currency, rate]) => ({
                ...rates,
                [currency]:
                  baseCurrency === currency
                    ? rate
                    : getAlpianExchange(rate, data.timestamp),
              }),
              {},
            ),
            timestamp: data.timestamp,
            isError: false,
          },
        }));
      } catch (_error) {
        setRates((state) => ({
          ...state,
          [baseCurrency]: {
            ...state[baseCurrency],
            isError: true,
          },
        }));
      }
    };

    Object.values(Currency).map(fetchRates);

    return () => {
      controller.abort();
    };
  }, []);

  return rates;
};
